import { GameDefinition } from './types';
import { vinhosRulebook } from './chapters';

export const VINHOS_GAME_ID = 'vinhos-deluxe';

const BOTH_VARIANTS_COMPAT = [
  {
    variantId: 'special-vintage-2016' as const,
    compatible: true,
    notes: 'Pełna treść dostępna dla Special Vintage 2016.',
  },
  {
    variantId: 'reserve-2010' as const,
    compatible: true,
    notes:
      'Zgodny z Reserve 2010 według oficjalnego arkusza; szczegóły w rozdziałach r2010-module-*.',
  },
];

export const vinhosEditions = [
  {
    id: 'special-vintage-2016',
    name: 'Special Vintage 2016',
    description:
      'Rekomendowany wariant pierwszej rozgrywki. Pełny pakiet nauki, szybka ściąga, FAQ i prowadzona gra.',
    recommendedForFirstGame: true,
    difficulty: 'standard' as const,
    mutuallyExclusiveWith: ['reserve-2010', 'vintage-2010'],
    contentStatus: 'ready' as const,
    activatable: true,
  },
  {
    id: 'reserve-2010',
    name: 'Reserve 2010',
    description:
      'Pełny, cięższy wariant z bankiem, cechami targów i magnatami na planszy. Pełna treść dostępna.',
    recommendedForFirstGame: false,
    difficulty: 'advanced' as const,
    mutuallyExclusiveWith: ['special-vintage-2016'],
    contentStatus: 'ready' as const,
    activatable: true,
  },
];

export const vinhosModules = [
  {
    id: 'experts',
    name: 'Experts',
    description:
      '32 nowe kafle ekspertów. Zgodny z 2016 i Reserve 2010 (Advertiser różni się procedurą).',
    recommendedForFirstGame: false,
    ruleChangesPlaceholder: 'Pełne reguły w rozdziale modułu aktywnego wariantu.',
    setupChangesPlaceholder: 'Przygotowanie w rozdziale modułu aktywnego wariantu.',
    scoringImpactPlaceholder: 'Wpływ opisuje rozdział modułu.',
    contentStatus: 'ready' as const,
    activatable: true,
    variantCompatibility: BOTH_VARIANTS_COMPAT.map((c) =>
      c.variantId === 'reserve-2010'
        ? {
            ...c,
            notes:
              'Zgodny. Advertiser: korzyść magnata bez wydawania wina.',
          }
        : c
    ),
  },
  {
    id: 'islands',
    name: 'Islands',
    description: 'Madera i Azory. Zgodny z oboma wariantami.',
    recommendedForFirstGame: false,
    ruleChangesPlaceholder: 'Pełne reguły w rozdziale modułu aktywnego wariantu.',
    setupChangesPlaceholder: 'Przygotowanie w rozdziale modułu aktywnego wariantu.',
    scoringImpactPlaceholder: 'Wpływ opisuje rozdział modułu.',
    contentStatus: 'ready' as const,
    activatable: true,
    variantCompatibility: BOTH_VARIANTS_COMPAT,
  },
  {
    id: 'tasting-room',
    name: 'Tasting Room',
    description:
      'Turyści i elementy deluxe. Zgodny z oboma wariantami — użyj strony kafla zatrudniania zgodnej z wariantem.',
    recommendedForFirstGame: false,
    ruleChangesPlaceholder: 'Pełne reguły w rozdziale modułu aktywnego wariantu.',
    setupChangesPlaceholder: 'Przygotowanie w rozdziale modułu aktywnego wariantu.',
    scoringImpactPlaceholder: 'Wpływ opisuje rozdział modułu.',
    contentStatus: 'ready' as const,
    activatable: true,
    variantCompatibility: BOTH_VARIANTS_COMPAT.map((c) =>
      c.variantId === 'reserve-2010'
        ? {
            ...c,
            notes:
              'Zgodny. Kafel Enolodzy/Farmerzy/Turyści stroną 2010; farmerzy stają się dostępni tą akcją.',
          }
        : c
    ),
  },
  {
    id: 'connoisseur',
    name: 'Connoisseur',
    description: 'Podwójne kafle, Filoksera, ocean. Zgodny z oboma wariantami.',
    recommendedForFirstGame: false,
    ruleChangesPlaceholder: 'Pełne reguły w rozdziale modułu aktywnego wariantu.',
    setupChangesPlaceholder: 'Przygotowanie w rozdziale modułu aktywnego wariantu.',
    scoringImpactPlaceholder: 'Wpływ opisuje rozdział modułu.',
    contentStatus: 'ready' as const,
    activatable: true,
    variantCompatibility: BOTH_VARIANTS_COMPAT,
  },
];

export const vinhosDeluxeGameListing = {
  id: VINHOS_GAME_ID,
  title: 'Vinhos Deluxe Edition',
  subtitle: 'Special Vintage 2016 · Reserve 2010 · 4 moduły',
  icon: '🍷',
  players: '1–4 graczy',
  playTime: '90–180 min',
  contentStatus: 'ready' as const,
  logoAccessibilityLabel: 'Logo gry Vinhos Deluxe Edition',
};

export const vinhosGameDefinition: GameDefinition = {
  game: vinhosDeluxeGameListing,
  shortTitle: 'Vinhos',
  author: 'Vital Lacerda',
  recommendedFirstGamePlayers: '2–3 graczy',
  difficulty: 'zaawansowana',
  instructionLanguage: 'polski',
  contentStatus: 'ready',
  editions: vinhosEditions,
  modules: vinhosModules,
  rulebook: vinhosRulebook,
};

export const FIRST_GAME_RECOMMENDATION =
  'Na pierwszą partię polecamy Special Vintage 2016 bez dodatków.';

export const RESERVE_FIRST_GAME_RECOMMENDATION =
  'Na pierwszą partię Reserve 2010 graj bez modułów, najlepiej w 2–3 osoby.';

export const MODULE_COMPLEXITY_WARNING =
  'Ten moduł zwiększa złożoność. Zalecamy dodać go dopiero po pierwszej pełnej rozgrywce.';

export const MODULE_AWAITING_LABEL = 'W przygotowaniu — nieaktywny';
export const MODULE_READY_LABEL = 'Pełna treść dostępna';
